<div class="card">
    <!-- TABS -->
    <p-tabs [(value)]="activeTab">
        <p-tablist>
            <p-tab value="clienti" class="flex items-center !gap-2 text-inherit">
                <i class="pi pi-users"></i>
                <span>Clienti</span>
            </p-tab>
            <p-tab value="fornitori" class="flex items-center !gap-2 text-inherit">
                <i class="pi pi-briefcase"></i>
                <span>Fornitori</span>
            </p-tab>
        </p-tablist>

        <p-tabpanels>
            <!-- PANEL CLIENTI -->
            <p-tabpanel value="clienti">
                <p-toolbar class="mb-3" [style]="{ 'background-color': '#f3f4f6', border: '0' }">
                    <ng-template pTemplate="start">
                        <div class="font-semibold text-2xl mb-4">Anagrafica Clienti</div>
                    </ng-template>

                    <ng-template pTemplate="end">
                        <div class="flex items-center gap-2">
                            <button pButton label="Nuovo cliente" icon="pi pi-plus" [size]="'large'" severity="success" (click)="nuovoCliente()"></button>
                        </div>
                    </ng-template>
                </p-toolbar>

                <p-table
                    #dtClienti
                    [value]="clienti"
                    [loading]="loadingClienti"
                    dataKey="id"
                    [paginator]="true"
                    [rows]="10"
                    [rowsPerPageOptions]="[10, 20, 50]"
                    [resizableColumns]="true"
                    [responsiveLayout]="'scroll'"
                    styleClass="p-datatable-striped p-datatable-sm"
                    [globalFilterFields]="['ragioneSociale', 'partitaIva', 'codiceFiscale', 'email', 'telefonoAzienda', 'nome', 'cognome', 'localita', 'paese', 'indirizzo', 'cap', 'cellulare', 'note']"
                >
                    <ng-template pTemplate="caption">
                        <div class="flex justify-between items-center">
                            <span class="text-sm text-500"></span>
                            <span class="p-input-icon-left">
                                <input pInputText type="text" (input)="dtClienti.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca…" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pResizableColumn pSortableColumn="ragioneSociale" style="width: 18rem">Ragione Sociale <p-sortIcon field="ragioneSociale"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="partitaIva" style="width: 12rem">P. IVA <p-sortIcon field="partitaIva"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="codiceFiscale" style="width: 12rem">Codice Fiscale <p-sortIcon field="codiceFiscale"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="indirizzo" style="width: 18rem">Indirizzo <p-sortIcon field="indirizzo"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="localita" style="width: 12rem">Località <p-sortIcon field="localita"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="paese" style="width: 14rem">Paese <p-sortIcon field="paese"></p-sortIcon></th>
                            <!-- <th pResizableColumn pSortableColumn="cap" style="width: 8rem">CAP <p-sortIcon field="cap"></p-sortIcon></th> -->
                            <!-- 
                            <th pResizableColumn pSortableColumn="telefonoAzienda" style="width: 12rem">Telefono <p-sortIcon field="telefonoAzienda"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="email" style="width: 20rem">Email <p-sortIcon field="email"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="nome" style="width: 12rem">Nome Ref. <p-sortIcon field="nome"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="cognome" style="width: 12rem">Cognome Ref. <p-sortIcon field="cognome"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="cellulare" style="width: 12rem">Cellulare <p-sortIcon field="cellulare"></p-sortIcon></th>
                            <th pResizableColumn pSortableColumn="note" style="width: 18rem">Note <p-sortIcon field="note"></p-sortIcon></th> -->
                            <th style="width: 240px">Azioni</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-r>
                        <tr>
                            <td class="white-space-pre-wrap">{{ r.ragioneSociale }}</td>
                            <td>{{ r.partitaIva }}</td>
                            <td>{{ r.codiceFiscale }}</td>
                            <td>{{ r.indirizzo }}</td>
                            <td>{{ r.localita }}</td>
                            <td>
                                <div class="flex items-center gap-2">
                                    <img [src]="getFlagUrl(r.paese)" class="w-4 h-3" alt="Paese" />
                                    <span>{{ getCountryName(r.paese) }}</span>
                                </div>
                            </td>
                            <!-- <td>{{ r.cap }}</td> -->

                            <!-- <td>{{ r.telefonoAzienda }}</td>
                            <td>{{ r.email }}</td>
                            <td>{{ r.nome }}</td>
                            <td>{{ r.cognome }}</td>
                            <td>{{ r.cellulare }}</td>
                            <td class="white-space-pre-wrap">{{ r.note }}</td> -->
                            <td>
                                <div class="flex gap-2">
                                    <button pButton icon="pi pi-pencil" [size]="'large'" severity="warn" (click)="modificaCliente(r)"></button>
                                    <button pButton icon="pi pi-trash" [size]="'large'" severity="danger" (click)="onElimina('cliente', r)"></button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="14">Nessun cliente trovato.</td>
                        </tr>
                    </ng-template>
                </p-table>

            </p-tabpanel>

            <!-- PANEL FORNITORI -->
            <p-tabpanel value="fornitori">
                <p-toolbar class="mb-3" [style]="{ 'background-color': '#f3f4f6', border: '0' }">
                    <ng-template pTemplate="start">
                        <div class="font-semibold text-2xl mb-4">Anagrafica Fornitori</div>
                    </ng-template>

                    <ng-template pTemplate="end">
                        <div class="flex items-center gap-2">
                            <button pButton label="Nuovo fornitore" icon="pi pi-plus" [size]="'large'" severity="success" (click)="nuovoFornitore()"></button>
                        </div>
                    </ng-template>
                </p-toolbar>

                <p-table
                    #dtFornitori
                    [value]="fornitori"
                    [loading]="loadingFornitori"
                    dataKey="id"
                    [expandedRowKeys]="expandedFornitori"
                    (onRowExpand)="onFornitoriRowExpand($event)"
                    (onRowCollapse)="onFornitoriRowCollapse($event)"
                    [paginator]="true"
                    [rows]="10"
                    [rowsPerPageOptions]="[10, 20, 50]"
                    [resizableColumns]="true"
                    [responsiveLayout]="'scroll'"
                    styleClass="p-datatable-striped p-datatable-sm"
                    [tableStyle]="{ 'min-width': '1200px' }"
                    [globalFilterFields]="['id', 'ragioneSociale', 'partitaIva', 'codiceFiscale', 'email', 'telefonoAzienda', 'nome', 'cognome', 'localita', 'paese']"
                >
                    <ng-template pTemplate="caption">
                        <div class="flex justify-between items-center">
                            <span class="text-sm text-500"></span>
                            <span class="p-input-icon-left">
                                <input pInputText type="text" (input)="dtFornitori.filterGlobal($any($event.target).value, 'contains')" placeholder="Cerca…" />
                            </span>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="ragioneSociale">Ragione Sociale <p-sortIcon field="ragioneSociale"></p-sortIcon></th>
                            <th pSortableColumn="partitaIva">P. IVA <p-sortIcon field="partitaIva"></p-sortIcon></th>
                            <th pSortableColumn="codiceFiscale">Codice Fiscale <p-sortIcon field="codiceFiscale"></p-sortIcon></th>
                            <th pSortableColumn="indirizzo">Indirizzo <p-sortIcon field="indirizzo"></p-sortIcon></th>
                            <!-- <th pSortableColumn="cap">CAP <p-sortIcon field="cap"></p-sortIcon></th> -->
                            <th pSortableColumn="localita">Località <p-sortIcon field="localita"></p-sortIcon></th>
                            <th pSortableColumn="paese">Paese <p-sortIcon field="paese"></p-sortIcon></th>
                            <!-- <th pSortableColumn="telefonoAzienda">Telefono Azienda <p-sortIcon field="telefonoAzienda"></p-sortIcon></th>
                            <th pSortableColumn="email">Email <p-sortIcon field="email"></p-sortIcon></th>
                            <th pSortableColumn="nome">Nome Referente <p-sortIcon field="nome"></p-sortIcon></th>
                            <th pSortableColumn="cognome">Cognome Referente <p-sortIcon field="cognome"></p-sortIcon></th>
                            <th pSortableColumn="cellulare">Cellulare <p-sortIcon field="cellulare"></p-sortIcon></th>
                            <th pSortableColumn="flgAttivo">Stato <p-sortIcon field="flgAttivo"></p-sortIcon></th>
                            <th pSortableColumn="note">Note <p-sortIcon field="note"></p-sortIcon></th> -->
                            <th style="width: 240px">Azioni</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-r>
                        <tr>
                            <td>{{ r.ragioneSociale }}</td>
                            <td>{{ r.partitaIva }}</td>
                            <td>{{ r.codiceFiscale }}</td>
                            <td>{{ r.indirizzo }}</td>
                            <!-- <td>{{ r.cap }}</td> -->
                            <td>{{ r.localita }}</td>
                            <td>
                                <div class="flex items-center gap-2">
                                    <img [src]="getFlagUrl(r.paese)" class="w-4 h-3" alt="Paese" />
                                    {{ r.paese }}
                                </div>
                            </td>
                            <!-- <td>{{ r.telefonoAzienda }}</td>
                            <td>{{ r.email }}</td>
                            <td>{{ r.nome }}</td>
                            <td>{{ r.cognome }}</td>
                            <td>{{ r.cellulare }}</td>
                            <td>
                                <p-badge [value]="r.flgAttivo ? 'Attivo' : 'Disattivo'" [severity]="r.flgAttivo ? 'success' : 'danger'" styleClass="text-sm px-3 py-2"> </p-badge>
                            </td>
                            <td>{{ r.note }}</td> -->
                            <td>
                                <div class="flex gap-2">
                                    <button pButton icon="pi pi-pencil" [size]="'large'" severity="warn" (click)="modificaFornitore(r)"></button>
                                    <button pButton icon="pi pi-trash" [size]="'large'" severity="danger" (click)="onElimina('fornitore', r)"></button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8">Nessun fornitore trovato.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabpanel>
        </p-tabpanels>

    </p-tabs>

    <p-toast></p-toast>
    <p-confirmDialog [style]="{ width: '450px' }" rejectButtonStyleClass="p-button-text" acceptLabel="Elimina" rejectLabel="Annulla" header="Confermi l'eliminazione?" icon="pi pi-exclamation-triangle"> </p-confirmDialog>
</div>
